export default {
  ResponseEnd: 'metric1',
  DomLoaded: 'metric2',
  WindowLoaded: 'metric3'
}



// WEBPACK FOOTER //
// ./plugins/my-analytics-plugin/src/metrics.js